import { AsyncPipe, NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { Criteria } from '@app/core/models/common.models';
import { ItemLabelComponent } from '@app/shared/components/campaign-adgroup-label/item-label.component';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';

@Component({
  selector: 'adspt-criterion-label',
  templateUrl: './item-label.component.html',
  styleUrls: ['./item-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgIf, AsyncPipe, TranslateModule, SharedDirectivesModule, NgTemplateOutlet],
})
export class CriterionLabelComponent extends ItemLabelComponent<Pick<Criteria, 'criterionName'>> {
  @Input()
  labelProperty = 'criterionName' as const;

  get type(): string {
    return 'common.criterion';
  }
}
